var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTundraSsi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 854,
    height: 790,
    viewBox: "0 0 854 790",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3058_92152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.264 594.602H853.393V716.779L780.204 668.404L673.861 713.677L566.264 668.403L473.058 754.61L372.342 783.14L327.928 746.548L292.897 693.831L259.742 725.462L185.926 664.062L134.63 671.505L77.08 622.509L2.63965 603.904L3.264 594.602Z",
    fill: "#384252",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 594.602V595.203H852.787V715.655L780.267 667.722L673.859 713.023L566.139 667.697L472.75 754.071L372.483 782.474L328.385 746.142L293.001 692.896L259.714 724.653L186.108 663.428L134.816 670.869L77.3663 621.961L3.27796 603.443L3.86903 594.642L3.26384 594.602V595.203V594.602L2.65865 594.562L2 604.364L76.7934 623.058L134.445 672.14L185.745 664.697L259.769 726.27L292.792 694.767L327.47 746.953L372.201 783.805L473.364 755.148L566.39 669.109L673.861 714.331L780.141 669.085L854 717.903V594H2.69597L2.65865 594.562L3.26384 594.602Z",
    fill: "#384252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26384 594.602V595.203H852.787V715.655L780.267 667.722L673.859 713.023L566.139 667.697L472.75 754.071L372.483 782.474L328.385 746.142L293.001 692.896L259.714 724.653L186.108 663.428L134.816 670.869L77.3663 621.961L3.27796 603.443L3.86903 594.642L3.26384 594.602ZM3.26384 594.602V595.203V594.602ZM3.26384 594.602L2.65865 594.562L2 604.364L76.7934 623.058L134.445 672.14L185.745 664.697L259.769 726.27L292.792 694.767L327.47 746.953L372.201 783.805L473.364 755.148L566.39 669.109L673.861 714.331L780.141 669.085L854 717.903V594H2.69597L2.65865 594.562L3.26384 594.602Z",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.5 485L518.83 278L513.5 485",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.5 475H435.5V480H473.5V475Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184 483.09H134V594.5H184V483.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175 552.09H145V588.5H175V552.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.15 537.09H141.85C140.828 537.09 140 537.918 140 538.94V539.65C140 540.672 140.828 541.5 141.85 541.5H151.15C152.172 541.5 153 540.672 153 539.65V538.94C153 537.918 152.172 537.09 151.15 537.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134 483.09H84V594.5H134V483.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125 552.09H95V588.5H125V552.09Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.71 493.54H143V526.07H174.71V493.54Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.891 520.29C152.891 520.743 152.756 521.186 152.505 521.562C152.253 521.939 151.895 522.232 151.477 522.406C151.058 522.579 150.598 522.624 150.154 522.536C149.71 522.448 149.302 522.23 148.981 521.909C148.661 521.589 148.443 521.181 148.355 520.737C148.266 520.293 148.312 519.832 148.485 519.414C148.658 518.995 148.952 518.638 149.328 518.386C149.705 518.134 150.148 518 150.601 518C150.902 517.999 151.2 518.057 151.478 518.172C151.757 518.286 152.01 518.455 152.223 518.668C152.436 518.881 152.604 519.134 152.719 519.412C152.834 519.691 152.892 519.989 152.891 520.29Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.151 520.29C161.113 520.87 160.855 521.414 160.431 521.811C160.007 522.208 159.447 522.429 158.866 522.429C158.285 522.429 157.726 522.208 157.301 521.811C156.877 521.414 156.62 520.87 156.581 520.29C156.56 519.977 156.604 519.664 156.71 519.368C156.815 519.073 156.98 518.803 157.194 518.574C157.409 518.345 157.667 518.163 157.955 518.038C158.243 517.913 158.553 517.849 158.866 517.849C159.18 517.849 159.49 517.913 159.777 518.038C160.065 518.163 160.324 518.345 160.538 518.574C160.752 518.803 160.917 519.073 161.023 519.368C161.128 519.664 161.172 519.977 161.151 520.29Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.42 520.29C169.42 520.743 169.286 521.186 169.034 521.562C168.782 521.939 168.425 522.232 168.006 522.406C167.588 522.579 167.127 522.624 166.683 522.536C166.239 522.448 165.831 522.23 165.511 521.909C165.19 521.589 164.972 521.181 164.884 520.737C164.795 520.293 164.841 519.832 165.014 519.414C165.187 518.995 165.481 518.638 165.858 518.386C166.234 518.134 166.677 518 167.13 518C167.431 517.999 167.729 518.057 168.008 518.172C168.286 518.286 168.539 518.455 168.752 518.668C168.965 518.881 169.134 519.134 169.248 519.412C169.363 519.691 169.421 519.989 169.42 520.29Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.401 495.33H172.071C172.169 495.327 172.267 495.344 172.359 495.379C172.451 495.415 172.536 495.468 172.607 495.536C172.679 495.603 172.736 495.685 172.776 495.775C172.816 495.865 172.838 495.962 172.841 496.06V511.06C172.838 511.159 172.816 511.256 172.776 511.346C172.736 511.436 172.679 511.517 172.607 511.585C172.536 511.652 172.451 511.705 172.359 511.741C172.267 511.776 172.169 511.793 172.071 511.79H145.401C145.203 511.793 145.011 511.718 144.867 511.582C144.724 511.445 144.639 511.258 144.631 511.06V496.06C144.639 495.862 144.724 495.675 144.867 495.538C145.011 495.402 145.203 495.327 145.401 495.33Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.461 496.77H146.691V510.03H171.461V496.77Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.16 609.61H495.34V697.31H528.16V609.61Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.551 697.34L502.631 697.61V737.24L508.081 739.55L508.621 738.6L515.161 738.87L515.841 739.42L520.201 737.5L520.611 736.69L521.001 697.5H527.931V789.5H495.581V697.42L495.551 697.34Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.471 697.59H501.001L501.051 737.52L511.711 740.34L522.641 736.63V697.56H528.001V789.5H495.521V697.59H495.471Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.49 616.19V789.5H528V609.91",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.49 616.19V789.5H528V609.91",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.621 622.44V767.95V622.44Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.621 622.44V767.95",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.511 767.69L464.701 771.15L495.511 773.5V767.72V767.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.511 780.01L464.701 783.5L495.511 785.81V780.03V780.01Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.051 780.01L558.871 783.5L528.051 785.81V780.03V780.01Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.051 767.69L558.871 771.15L528.051 773.5V767.72V767.69Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.611 597.64H493.971V599.37H495.611V597.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.931 597.64H506.291V599.37H507.931V597.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.37 597.64H515.73V599.37H517.37V597.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.98 597.64H528.34V599.37H529.98V597.64Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.25 588.5L493.32 597.62H530.24V588.5H493.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.211 594.5L530.311 594.57L493.211 594.5Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.211 594.5L530.311 594.57",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.59 597.76H528L527.93 609.94L495.57 616.19V597.76H495.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 2.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 615.17V627.1L522.66 622.43V610.92L501 615.17Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.67 625.7V658.5L511.77 652.15L515.6 654.89V624.02L507.67 625.71V625.7Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 627.04V768.12V627.04Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501 627.04V768.12",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.92 768.05V762.5H502.58V670.02H501",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.92 768.05V762.5H502.58V670.02H501",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.881 663.14L514.881 666.14V697.5H515.881V705.4H507.631V697.4H508.691V667.38L511.861 663.15L511.881 663.14Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.611 754.81H508.081H502.611Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.611 754.81H508.081",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.631 758.32C515.633 759.078 515.41 759.819 514.99 760.451C514.57 761.082 513.973 761.574 513.273 761.866C512.574 762.157 511.803 762.234 511.06 762.088C510.316 761.941 509.633 761.577 509.096 761.042C508.559 760.507 508.194 759.824 508.045 759.081C507.896 758.338 507.972 757.567 508.261 756.867C508.551 756.166 509.042 755.567 509.672 755.146C510.302 754.725 511.043 754.5 511.801 754.5C512.815 754.5 513.787 754.902 514.505 755.618C515.223 756.334 515.628 757.306 515.631 758.32Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.61 670.05H521V762.5H515.68V767.87",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.61 670.05H521V762.5H515.68V767.87",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.001 706.74L503.281 710.93V737.5L507.781 739.42",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.001 706.74L503.281 710.93V737.5L507.781 739.42",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.631 706.74L520.351 710.93V737.5L515.851 739.42",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.631 706.74L520.351 710.93V737.5L515.851 739.42",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.611 726.23L520.381 727.8L515.611 726.23Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.611 726.23L520.381 727.8",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.66 736.1C515.66 736.857 515.435 737.598 515.015 738.228C514.594 738.858 513.995 739.349 513.296 739.638C512.596 739.928 511.826 740.004 511.083 739.856C510.34 739.709 509.657 739.344 509.122 738.808C508.586 738.273 508.221 737.59 508.074 736.847C507.926 736.104 508.002 735.334 508.292 734.634C508.581 733.934 509.072 733.336 509.702 732.915C510.332 732.495 511.072 732.27 511.83 732.27C512.846 732.27 513.82 732.674 514.538 733.392C515.256 734.11 515.66 735.084 515.66 736.1Z",
    fill: "#131F2E",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.4 754.81H520.86H515.4Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.4 754.81H520.86",
    stroke: "#F7F9F9",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.051 726.23L503.291 727.8L508.051 726.23Z",
    fill: "#131F2E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.051 726.23L503.291 727.8",
    stroke: "#F7F9F9",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.5 563.5H501V577H524.5V563.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523 575.5H501.5V589H523V575.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M524.5 560.5H499.5V563H524.5V560.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.5 586H525.5V587H527.5V586Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.5 586H521.5V587H523.5V586Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M523.5 557.5H500.5V560H523.5V557.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.5 554H503.5V590H521.5V554Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.5 528H507.5V532H525.5V528Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.5 532H525.5V537.91C525.5 538.316 525.42 538.718 525.265 539.092C525.11 539.467 524.882 539.808 524.595 540.095C524.308 540.382 523.968 540.609 523.593 540.765C523.218 540.92 522.816 541 522.41 541H510.58C509.761 541 508.975 540.674 508.395 540.095C507.816 539.515 507.49 538.73 507.49 537.91V532H507.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445.5 555H431.5V595H445.5V555Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.5 554H275.5V594H292.5V554Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.5 554H234.5V594H251.5V554Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.5 528H234.5V556H284.5V528Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M521.5 526H275.5V557H521.5V526Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.5 489H442.5V513H515.5V489Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.5 513H437.5V518H520.5V513Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440.5 518H437.5V526H440.5V518Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.5 485H442.5V489H515.5V485Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.5 480H468.5V485H493.5V480Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M491.5 305H470.5V480H491.5V305Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5 299H460.5V485H470.5V299Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M468.5 264H436.5V282H468.5V264Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.5 275H436.5V292H441.5V275Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5 455H463.5V457H470.5V455Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449.5 284H447.5V485H449.5V284Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.5 36H402.5V526H429.5V36Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.5 474H444.5V485H452.5V474Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.5 384H508.5V485H512.5V384Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.5 466H506.5V481H515.5V466Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.26 463H513.73C514.197 463 514.645 463.185 514.975 463.516C515.305 463.846 515.49 464.293 515.49 464.76V467H506.49V464.76C506.49 464.528 506.536 464.298 506.625 464.084C506.714 463.87 506.845 463.676 507.009 463.512C507.174 463.348 507.369 463.219 507.584 463.131C507.798 463.043 508.028 462.999 508.26 463Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520.5 518H516.99V525.73H520.5V518Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.5 518.73H509.99V526H512.5V518.73Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5 383H463.5V385H470.5V383Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5 406H459.5V407H470.5V406Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5 362H459.5V363H470.5V362Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5 334H463.5V336H470.5V334Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5 313H459.5V314H470.5V313Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M470.5 444H459.5V445H470.5V444Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.5 308C502.935 308 519.5 291.435 519.5 271C519.5 250.565 502.935 234 482.5 234C462.065 234 445.5 250.565 445.5 271C445.5 291.435 462.065 308 482.5 308Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.25 276V229.5H477.25V276H486.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488 276.5V229.5H486V276.5H488Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M478 276.5V229.5H476V276.5H478Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.5 526V223H431.5V526H436.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.5 526V223H395.5V526H400.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 511.011L431.516 508.011L400.516 508.017L400.516 511.017L431.516 511.011Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 495.218L431.516 492.218L400.516 492.224L400.516 495.224L431.516 495.218Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 479.206L431.516 476.206L400.516 476.211L400.516 479.211L431.516 479.206Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 463.203L431.516 460.203L400.516 460.208L400.516 463.208L431.516 463.203Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 448.19L431.516 445.19L400.516 445.196L400.516 448.196L431.516 448.19Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.506 431.187L431.506 428.187L400.506 428.193L400.506 431.193L431.506 431.187Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 415.184L431.516 412.184L400.516 412.19L400.516 415.19L431.516 415.184Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 401.172L431.516 398.172L400.516 398.177L400.516 401.177L431.516 401.172Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.49 407.77V404.93H406.49V407.77H409.49Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.506 384.169L431.506 381.169L400.506 381.174L400.506 384.174L431.506 384.169Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 368.156L431.516 365.156L400.516 365.162L400.516 368.162L431.516 368.156Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 352.153L431.516 349.153L400.516 349.159L400.516 352.159L431.516 352.153Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 336.151L431.516 333.151L400.516 333.156L400.516 336.156L431.516 336.151Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.506 320.138L431.506 317.138L400.506 317.143L400.506 320.143L431.506 320.138Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 305.125L431.516 302.125L400.516 302.131L400.516 305.131L431.516 305.125Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 289.123L431.516 286.123L400.516 286.128L400.516 289.128L431.516 289.123Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 273.12L431.516 270.12L400.516 270.125L400.516 273.125L431.516 273.12Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 257.117L431.516 254.117L400.516 254.122L400.516 257.122L431.516 257.117Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.506 241.114L431.506 238.114L400.506 238.119L400.506 241.119L431.506 241.114Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.516 226.102L431.516 223.102L400.516 223.107L400.516 226.107L431.516 226.102Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.471 33.74V36H402.471V33.74C402.471 32.4829 402.97 31.2772 403.859 30.3883C404.748 29.4994 405.954 29 407.211 29H424.731C425.988 29 427.193 29.4994 428.082 30.3883C428.971 31.2772 429.471 32.4829 429.471 33.74Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.451 309.973L429.451 309.093L402.451 309.103L402.451 309.983L429.451 309.973Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.75 237.5C482.302 237.5 482.75 237.052 482.75 236.5C482.75 235.948 482.302 235.5 481.75 235.5C481.198 235.5 480.75 235.948 480.75 236.5C480.75 237.052 481.198 237.5 481.75 237.5Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.5 267.75H440.5V276.75H525.5V267.75Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.5 266H440.5V268H525.5V266Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.5 276H440.5V278H525.5V276Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.5 273.25C448.052 273.25 448.5 272.802 448.5 272.25C448.5 271.698 448.052 271.25 447.5 271.25C446.948 271.25 446.5 271.698 446.5 272.25C446.5 272.802 446.948 273.25 447.5 273.25Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M517.5 273C518.052 273 518.5 272.552 518.5 272C518.5 271.448 518.052 271 517.5 271C516.948 271 516.5 271.448 516.5 272C516.5 272.552 516.948 273 517.5 273Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M424.59 407.77V404.93H421.59V407.77H424.59Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.041 315.82V312.98H407.041V315.82H410.041Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.15 315.82V312.98H422.15V315.82H425.15Z",
    fill: "#131F2E",
    stroke: "#F7F9F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3058_92152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 854,
    height: 790,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTundraSsi);
export default __webpack_public_path__ + "static/media/tundra-ssi.6fe919b4cbb15c0752bde049dd042aae.svg";
export { ForwardRef as ReactComponent };